import React, { Component } from 'react';
import {
  Row,
  Col,
  Card,
  Form, FormGroup, Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupButton,
  CardHeader,
  CardBody,
  CardFooter,
  CardGroup,
  Collapse, Button, Fade, Jumbotron,
  ListGroup, ListGroupItem, ListGroupItemHeading, ListGroupItemText,
  Table
} from 'reactstrap';
import v from 'voca';
import { inject, observer } from "mobx-react";
import { MakeForm, makeInput } from "common-import/custom";
import { Request, VarHelper } from "common-import/helpers";

const defaultImage = "http://jimenezylievanoabogados.com/en/wp-content/themes/jimenezylievanoabogados/images/no_image_profile.jpg";
const initial = {
  message: "",
  keyword: "",
  listCompany: [],
  name: "",
  firstName: "",
  lastName: "",
  email: "",
  companyTaxCode: "",
  phone: "",
  gender: "",
  mobile: "",
  avatar: "",
  position: "",
  multiple: [],
  file: null,
  isSaving: false,
  isUploading: false,
};

@inject("contactStore", "companyInfoStore", "userStore", "contractorStore") @observer
class ImportContact extends Component {

  constructor() {
    super();
    this.state = initial
  }

  uploadXLSX = (e) => {
    !!e && e.preventDefault();
    this.setState({
      isUploading: true,
      file: e.target.files[0]
    });
    VarHelper.readXLSX(e, (data) => {
      this.setState({
        isUploading: false,
        multiple: VarHelper.formatDataXLSX(data),
      });
    });
  };

  formatPayload = (data) => {
    let copy;

    const typeFormat = {
      typeString: ["name", "firstName", "lastName", "email", "phone", "mobile", "gender", "avatar", "position", "companyTaxCode", "userId"],
    };

    let keyList = [];
    for (let key in typeFormat) {
      keyList = [...keyList, ...typeFormat[key]];
    }

    copy = VarHelper.copyObjectWithKey(keyList, data);
    return VarHelper.formatValueByType(copy, typeFormat);
  };

  submitMultiple = async () => {
    const { contactStore, userStore } = this.props;
    const { multiple } = this.state;
    if (!multiple.length) return null;
    this.setState({ isSaving: true });
    for (let i = 0; i < multiple.length; i++) {
      // uploadStatus: 0 - uploading, 1 - uploaded success, 2 - uploaded failure
      multiple[i]['uploadStatus'] = 0;
      this.setState({ multiple });
      multiple[i]['userId'] = await this.getUserId(multiple[i].email);
      const payload = this.formatPayload(multiple[i]);
      const res = await contactStore.createContact(payload);
      if (!!res.error) {
        multiple[i]['uploadStatus'] = 2;
        multiple[i]['uploadErrorMessage'] = res.error;
      } else {
        multiple[i]['uploadStatus'] = 1;
      }
      this.setState({ multiple });
    }
    window.toast.info("Finish!");
    this.setState({ isSaving: false, file: null });
  };

  getUserId = async (email) => {
    const { userStore } = this.props;
    const res = await userStore.search({email});
    if (!res.error && res.data.id) return res.data[0].id;
    return null;
  };

  reset = () => {
    this.setState({
      multiple: [],
      file: null,
      isSaving: false,
      isUploading: false,
    });
  };

  renderMultipleImport = () => {
    const { isSaving, multiple, file, isUploading } = this.state;
    const adding = multiple.filter(item => item.hasOwnProperty('uploadStatus') && item.uploadStatus === 0);
    const successList = multiple.filter(item => item.hasOwnProperty('uploadStatus') && item.uploadStatus === 1);
    const errorList = multiple.filter(item => item.hasOwnProperty('uploadStatus') && item.uploadStatus === 2);
    const renderUploading = () => {
      if (!isSaving && multiple.length) return (<h6>{multiple.length} items will be added.</h6>);
      else if (isSaving && multiple.length) return (<h6>Adding: {adding.length && !!adding[0].name ? adding[0].name : ''}</h6>);
    };
    const style = {
      maxHeight: '256px',
      overflowY: 'auto',
    };
    const renderSuccessList = () => {
      return <div style={{marginTop: '16px'}}>
        <h6>Success ({successList.length})</h6>
        <div style={style}>
          {successList.map((item, index) => {
            return <p className="text-success" key={'success'+index}>(STT: {item.STT}) {item.name}</p>
          })}
        </div>
      </div>
    };
    const renderErrorList = () => {
      return <div style={{marginTop: '24px'}}>
        <h6>Failure ({errorList.length})</h6>
        <div style={style}>
          {errorList.map((item, index) => {
            return <p className="text-danger" key={'success'+index}>(STT: {item.STT}) {item.name} - {item.uploadErrorMessage}</p>
          })}
        </div>
      </div>
    };
    return (
      <Card>
        <CardHeader>
          <i className="fa fa-envelope-open"> </i> Create multiple contacts - Upload files
        </CardHeader>
        <CardBody>
          <div style={{marginBottom: '16px'}}>
            <a target="_blank" href="https://drive.google.com/drive/folders/1YjwJTADWCYt3C5RoS-G0JOmFeDHT28AG?usp=drive_open">
              Sample data here
            </a>
          </div>
          <Form action="" method="post" className="form-horizontal">
            <FormGroup>
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <div style={{marginBottom: 0}} className="form-group group-file-upload">
                    <input onChange={e => this.uploadXLSX(e)} type="file" id="upload-files" name="upload-files" style={{display: "none"}}/>
                    <label className="btn btn-primary" htmlFor="upload-files"><i className="fa fa-file"> </i> {isUploading ? 'Uploading...' : 'Upload'}</label>
                  </div>
                </InputGroupAddon>
                <Input type="text" disabled={true} value={!!file ? file.name : 'File path .xlsx .xls'}/>
              </InputGroup>
            </FormGroup>
          </Form>
          {renderUploading()}
          {successList.length ? renderSuccessList() : null}
          {errorList.length ? renderErrorList() : null}
        </CardBody>
        <CardFooter>
          <button type="submit" className="btn btn-sm btn-success" disabled={isSaving} onClick={() => this.submitMultiple()}>
            <i className="fa fa-dot-circle-o"> </i> {isSaving ? 'Submitting...' : 'Submit'}
          </button>
          <Button type="reset" size="sm" color="danger" onClick={() => this.reset()}>
            <i className="fa fa-ban"> </i> Clear
          </Button>
        </CardFooter>
      </Card>
    );
  };

  renderSingleImport = () => {
    const { keyword, message } = this.state;
    const avatar = this.state.avatar !== "" ? this.state.avatar : defaultImage;

    return (
      <Card>
        <CardHeader>
          <i className="fa fa-envelope-open"> </i> Create a contact
        </CardHeader>
        <CardBody>
          <Form onSubmit={this.search}>
            <FormGroup>
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <Button type="button" color="primary" onClick={this.search}><i className="fa fa-search"> </i> Search</Button>
                </InputGroupAddon>
                {makeInput(this, "keyword")(<Input type="text" placeholder="Enter the company's name or company tax code to add contact" />)}
              </InputGroup>
            </FormGroup>
          </Form>
          <Form onSubmit={this.searchOldId}>
            <FormGroup row>
              <Col md="12">
                <InputGroup>
                  <InputGroupAddon addonType="prepend">
                    <Button type="button" color="primary" onClick={this.searchOldId}><i className="fa fa-search"> </i> Search by Old ID</Button>
                  </InputGroupAddon>
                  {makeInput(this, "oldId")(<Input type="text" id="input1-group2" name="input1-group2" placeholder="Type old id" />)}
                </InputGroup>
              </Col>
            </FormGroup>
          </Form>
          {message !== "" && <p style={{ marginBottom: 20, testAlign: "center", display: "block", fontWeight: "bold", color: "green" }}>{message}</p>}
          {this.renderCompanyList()}
          <Form action="" method="post" onSubmit={this.submitCreateOneUser}>
            <FormGroup>
              <Label >Company Tax Code</Label>
              {makeInput(this, "companyTaxCode")(<Input type="text" readOnly />)}
            </FormGroup>
            <FormGroup>
              <Label >Display Name</Label>
              {makeInput(this, "name")(<Input type="text" />)}
            </FormGroup>
            <FormGroup>
              <Label >First Name</Label>
              {makeInput(this, "firstName")(<Input type="text" />)}
            </FormGroup>
            <FormGroup>
              <Label >Last name</Label>
              {makeInput(this, "lastName")(<Input type="text" />)}
            </FormGroup>
            <FormGroup>
              <Label >Email</Label>
              {makeInput(this, "email")(<Input type="text" />)}
            </FormGroup>
            <FormGroup>
              <Label >Phone</Label>
              {makeInput(this, "phone")(<Input type="text" />)}
            </FormGroup>
            <FormGroup>
              <Label >Mobile</Label>
              {makeInput(this, "mobile")(<Input type="text" />)}
            </FormGroup>
            <FormGroup>
              <Label >Gender</Label>
              <select className="form-control"
                onChange={e => this.setState({gender: e.target.value})}
              >
                <option value="___">___</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
              </select>
            </FormGroup>
            <FormGroup>
              <Label >Job title (position)</Label>
              {makeInput(this, "position")(<Input type="text" />)}
            </FormGroup>
            <FormGroup>
              <Label> </Label>
              <div style={{
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                display: "flex"
              }}>
                {<img src={avatar} style={{ width: 200, height: 200, borderRadius: "100%", marginBottom: 20 }} />}
                <input type="file" id={"upload-avatar"} name={"upload-avatar"} style={{ display: "none" }} multiple onChange={this.uploadAvatar} />
                <label className="btn btn-sm btn-danger" htmlFor={"upload-avatar"}><i className="fa fa-camera"> </i> Upload Images</label>
              </div>
            </FormGroup>
          </Form>
        </CardBody>
        <CardFooter>
          <Button type="submit" size="sm" color="primary" onClick={this.createContact}><i className="fa fa-dot-circle-o"> </i> Save</Button>
          <Button type="reset" size="sm" color="danger" onClick={this.clear}><i className="fa fa-ban"> </i> Cancel</Button>
        </CardFooter>
      </Card>
    )
  };

  renderCompanyList = () => {
    const { listCompany } = this.state;
    return (
      <div style={{ maxHeight: 100, overflow: "auto", marginBottom: 20 }}>
        {listCompany.map((val, index) => (
          <p className="cursor hover-underline" key={"comp" + index} onClick={() => this.chooseCompany(val)}>{val.name}</p>
        ))}
      </div>
    )
  };

  render() {
    return (
      <div className="animated fadeIn">
        <div className="row">
          <div className="col-md-6">
            {this.renderSingleImport()}
          </div>
          <div className="col-md-6">
            {this.renderMultipleImport()}
          </div>
        </div>
      </div>
    );
  };

  search = async (e) => {
    !!e && e.preventDefault();
    this.setState({ message: "Searching..." });
    const { contractorStore, companyInfoStore } = this.props;
    const { keyword } = this.state;
    const isNumber = !isNaN(keyword);
    const findObject = isNumber ? { taxCode: keyword } : { name : keyword };
    let companyResult = await contractorStore.simpleSearch(findObject);
    if (!!companyResult.error) {
      this.setState({ message: "", companyList: companyResult.data });
      return window.toast.error("Error occurred, please try again " + JSON.stringify(companyResult.error));
    }
    this.setState({ listCompany: companyResult.data, message: companyResult.data.length > 0 ? "" : "Company not found." })
  };

  searchOldId = async (e) => {
    !!e && e.preventDefault();
    this.setState({ message: "Searching..." });
    const { contractorStore } = this.props;
    const { oldId } = this.state;
    let companyResult = await contractorStore.searchByOldId(oldId);
    if (!!companyResult.error) {
      this.setState({ message: "", companyList: companyResult.data });
      return window.toast.error("Error occurred, please try again " + JSON.stringify(companyResult.error));
    }
    this.setState({ listCompany: [companyResult.data], message: [companyResult.data].length > 0 ? "" : "Company not found." })
  }

  chooseCompany = (val) => {
    this.setState({
      listCompany: [],
      message: "Filled this form bellow with companyTaxCode of " + val.name,
      companyTaxCode: val.taxCode
    })
  };

  uploadAvatar = async (e) => {
    const file = e.target.files[0];
    const uploadedUrl = await Request.upload(file);
    this.setState({ avatar: uploadedUrl });
  };

  clear = e => {
    !!e && e.preventDefault();
    this.setState(initial);
  };

  createContact = async (e) => {
    !!e && e.preventDefault();
    const { contactStore } = this.props;
    const { companyTaxCode, name, firstName, lastName, mobile, gender, email, phone, position, avatar } = this.state;
    const newContactObject = VarHelper.filterEmptyObjProp({ companyTaxCode, name, mobile, gender, firstName, lastName, email, phone, position, avatar });
    const res = await contactStore.createContact(newContactObject);
    if (!!res.error) {
      return window.toast.error("Error, please try again " + JSON.stringify(res.error));
    }
    window.toast.info("Created successfully.");
    this.clear();
  }
}

export default ImportContact;



// WEBPACK FOOTER //
// ./src/views/Contacts/Import.js